import { Injectable } from '@angular/core';
import { Log } from '../models/log.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from 'src/app/core/account/auth.service';
import { take } from 'rxjs/operators';
import { getLocaleDateFormat } from '@angular/common';
import { GlobalService } from './global.service';
import { SMS } from '../models/sms.model';
import { Email } from '../models/email.model';
import { Contact } from '../models/contact.model';
import { MessageTemplate } from '../models/template.model';
import { Scope } from '../models/scope.model';
import { BatchText, DirectBatchText } from '../models/batch-text.model';
import { BatchEmail, DirectBatchEmail } from '../models/batch-email.model';
import { attachment } from '../attachment/attachment.model';
import { BatchNotification, DirectBatchNotification } from '../models/batch-notification.model';

@Injectable({ providedIn: 'root' })
export class ContactService {
  apiHost: string = environment.apiHost;

  constructor(private http: HttpClient, private globalService: GlobalService) {}

  getContacts(events: any): Promise<Contact[]> {
    let promise = new Promise<Contact[]>((resolve, reject) => {
      return this.http
        .get<Contact[]>(
          this.apiHost +
            '/user/getContacts?Scope=' +
            events.scope +
            '&Detail=' +
            events.detail
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllContacts(): Promise<Contact[]> {
    let promise = new Promise<Contact[]>((resolve, reject) => {
      return this.http
        .get<Contact[]>(this.apiHost + '/user/getallcontacts')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  getScopeHierarchy(): Promise<Scope[]> {
    let promise = new Promise<Scope[]>((resolve, reject) => {
      return this.http
        .get<Scope[]>(this.apiHost + '/user/getScopeHierarchy')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  getTextCounter(): Promise<number> {
    let promise = new Promise<number>((resolve, reject) => {
      return this.http
        .get<number>(this.apiHost + '/contact/GetTextCounter')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  SendBatchSMS(input: BatchText, eventId: number): Promise<any> {
    if (eventId == undefined) eventId = 0;
    let promise = new Promise<SMS>((resolve, reject) => {
      return this.http
        .post<SMS>(
          this.apiHost + '/contact/SendBatchSMS?EventId=' + eventId.toString(),
          input
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  SendDirectBatchSMS(input: DirectBatchText, eventId: number): Promise<any> {
    if (eventId == undefined) eventId = 0;
    let promise = new Promise<SMS>((resolve, reject) => {
      return this.http
        .post<SMS>(
          this.apiHost +
            '/contact/SendDirectBatchSMS?EventId=' +
            eventId.toString(),
          input
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  SendBatchEmails(input: BatchEmail, eventId: number): Promise<any> {
    if (eventId == undefined) eventId = 0;
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<BatchEmail>(
          this.apiHost +
            '/contact/SendBatchEmails?EventId=' +
            eventId.toString(),
          input
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  SendDirectBatchEmails(
    input: DirectBatchEmail,
    eventId: number
  ): Promise<any> {
    if (eventId == undefined) eventId = 0;
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<BatchEmail>( 
          this.apiHost +
            '/contact/SendDirectBatchEmails?EventId=' +
            eventId.toString(),
          input
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  SendBatchNotifications(input: BatchNotification, eventId: number): Promise<any> {
    if (eventId == undefined) eventId = 0;
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<BatchNotification>(
          this.apiHost +
            '/contact/SendBatchNotifications?EventId=' +
            eventId.toString(),
          input
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }  

    SendDirectBatchNotifications(input: DirectBatchNotification, eventId: number): Promise<any> {
    if (eventId == undefined) eventId = 0;
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<DirectBatchNotification>(
          this.apiHost +
            '/contact/SendDirectBatchNotifications?EventId=' +
            eventId.toString(),
          input
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }  

  // Status 1 => Attendees only, 2 Absentees Only, 3 Both
  getEventCounter(EventId: number, Status: number): Promise<number> {
    let promise = new Promise<number>((resolve, reject) => {
      return this.http
        .get<number>(
          this.apiHost +
            '/contact/GetEventCount?EventId=' +
            EventId +
            '&Status=' +
            Status
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject(msg['statusText']);
          }
        );
    });
    return promise;
  }

  getNotificationTemplates(): Promise<MessageTemplate[]> {
    let promise = new Promise<MessageTemplate[]>((resolve, reject) => {
      return this.http
        .get<MessageTemplate[]>(this.apiHost + '/template/GetNotificationTemplates')
        .toPromise()
        .then(
          (data) => {
            resolve(data['result']);
          },
          (msg) => {
            reject(msg['statusText']);
          }
        );
    });
    return promise;
  }  

  getEmailTemplates(): Promise<MessageTemplate[]> {
    let promise = new Promise<MessageTemplate[]>((resolve, reject) => {
      return this.http
        .get<MessageTemplate[]>(this.apiHost + '/template/GetEmailTemplates')
        .toPromise()
        .then(
          (data) => {
            resolve(data['result']);
          },
          (msg) => {
            reject(msg['statusText']);
          }
        );
    });
    return promise;
  }

  getTextTemplates(): Promise<MessageTemplate[]> {
    let promise = new Promise<MessageTemplate[]>((resolve, reject) => {
      return this.http
        .get<MessageTemplate[]>(this.apiHost + '/template/GetTextTemplates')
        .toPromise()
        .then(
          (data) => {
            resolve(data['result']);
          },
          (msg) => {
            reject(msg['statusText']);
          }
        );
    });
    return promise; 
  }

  saveTemplate(template: MessageTemplate): Promise<MessageTemplate> {
    let promise = new Promise<MessageTemplate>((resolve, reject) => {
      return this.http
        .post<MessageTemplate>(
          this.apiHost + '/template/SaveTemplate',
          template
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['result']);
          },
          (msg) => {
            reject(msg['statusText']);
          }
        );
    });
    return promise;
  }

  deleteTemplate(templateId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/template/DeleteTemplate?templateId=' + templateId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            reject(null);
          }
        );
    });
    return promise;
  }  

  readTemplate(
    userId: string
  ): Promise<{ emailTemplate: string; textTemplate: string }> {
    let promise = new Promise<{ emailTemplate: string; textTemplate: string }>(
      (resolve, reject) => {
        return this.http
          .get<{ emailTemplate: string; textTemplate: string }>(
            this.apiHost + '/template/ReadTemplate?UserId=' + userId.toString()
          )
          .toPromise()
          .then(
            (data) => {
              resolve(data['result']);
            },
            (msg) => {
              reject(msg);
            }
          );
      }
    );
    return promise;
  }
}
